import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { editorStoreIds } from '../../../guards/auth/roles';
import { GlobalDataService } from '../../../services/global-data/global-data.service';
import { StoreService } from '../../../services/store/store.service';
import { Store } from '../../../types';

@Component({
  standalone: true,
  template: `
    <main class="container py-5">
      <h1>Vælg butik</h1>
      @if (error) {
        <p role="alert">Dine butikker kunne ikke indlæses.</p>
        <button type="button" class="btn btn-outline-primary" (click)="ngOnInit()">Prøv igen</button>
      } @else if (!stores.length) {
        <p>Indlæser butikker…</p>
      }
      <ul class="list-unstyled">
        @for (store of stores; track store.id) {
          <li class="mb-2"><button type="button" class="btn btn-outline-primary" (click)="select(store)">
            {{ store.place }} ({{ store.id }})
          </button></li>
        }
      </ul>
    </main>
  `,
})
export class SelectStoreComponent implements OnInit {
  private global = inject(GlobalDataService);
  private router = inject(Router);
  private storeService = inject(StoreService);
  private destroyRef = inject(DestroyRef);
  private cdr = inject(ChangeDetectorRef);
  stores: Store[] = [];
  error = false;

  ngOnInit(): void {
    this.error = false;
    const generation = this.global.getAuthenticationGeneration();
    const ids = editorStoreIds(this.global.getSessionData().value);
    if (!ids.length) return;
    forkJoin(ids.map(id => this.storeService.getStoreById(id)))
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: stores => {
        if (!this.global.isAuthenticationCurrent(generation)) return;
        const allowed = editorStoreIds(this.global.getSessionData().value);
        this.stores = stores.filter((store): store is Store => !!store && allowed.includes(store.id));
        this.error = !this.stores.length;
        this.cdr.markForCheck();
        if (this.stores.length === 1 && ids.length === 1) this.select(this.stores[0]);
      },
      error: () => { this.error = true; this.cdr.markForCheck(); },
    });
  }

  select(store: Store): void {
    if (!editorStoreIds(this.global.getSessionData().value).includes(store.id)) return;
    this.global.selectEditorStore(store);
    void this.router.navigate(['/overview']);
  }
}
